var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58339 9.08312V2.56729L8.43006 5.41395C8.65756 5.64145 9.03089 5.64145 9.25839 5.41395C9.48589 5.18645 9.48589 4.81895 9.25839 4.59145L5.41422 0.747285C5.18672 0.519785 4.81922 0.519785 4.59172 0.747285L0.747556 4.59145C0.520056 4.81895 0.520056 5.18645 0.747556 5.41395C0.975056 5.64145 1.34256 5.64145 1.57006 5.41395L4.41672 2.56729L4.41672 9.08312C4.41672 9.40395 4.67922 9.66645 5.00006 9.66645C5.32089 9.66645 5.58339 9.40395 5.58339 9.08312Z",
    fill: "#1EBC61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.356215f130c939314bbbca6d8a01f31d.svg";
export { ForwardRef as ReactComponent };